import { render, staticRenderFns } from "./BusinessProfileDetails.vue?vue&type=template&id=7e4ea02e"
import script from "./BusinessProfileDetails.vue?vue&type=script&lang=js"
export * from "./BusinessProfileDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports